import React from "react"
import type { ParametrosClienteFielModel } from "../models/parametrosClienteFielModel"
import { ParametrosClienteFielInicial } from "../models/parametrosClienteFielModel"
import type { ParametrosClienteFielActionModel } from "./parametrosClienteFielActions"
import { parametrosClienteFielReducer } from "./parametrosClienteFielReducer"

type ParametrosClienteFielContextType = {
    parametros: ParametrosClienteFielModel
    dispatch: React.Dispatch<ParametrosClienteFielActionModel>
    salvar: () => Promise<void>
    erroCarregamento: string | null
}

export const ParametrosClienteFielContext = React.createContext<ParametrosClienteFielContextType>({
    parametros: ParametrosClienteFielInicial,
    dispatch: () =>
        parametrosClienteFielReducer(ParametrosClienteFielInicial, {
            type: "CARREGAR" as never,
            payload: ParametrosClienteFielInicial,
        }),
    salvar: async () => {},
    erroCarregamento: null,
})
